import Anchor from "./dls/anchor";

const ConvertKitForm = () => {
  return (
    <div className="bg-white max-w-2xl mx-auto">
      <div className="mx-auto max-w-7xl py-12 px-4 md:py-16">
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          <span className="block">Ready to Start?</span>
          <span className="block text-drDocBlue">
            Start using Dr.Doc AI for Free.
          </span>
        </h2>
        <div className="mt-8 flex">
          <div className="inline-flex">
            <Anchor
              href="/blog"
              className="text-center items-center justify-center w-full my-4 border  border-drDocBlue text-drDocBlue hover:bg-purple-50 rounded-lg py-3 flex flex-row px-4 gap-2"
            >
              Explore Blogs{" "}
            </Anchor>
          </div>
          <div className="ml-3 inline-flex">
            <a
              href="https://client.drdoc.ai/register"
              target="_blank"
              rel="noreferrer"
              className="w-max border border-gray-800 hover:text-gray-900 my-4 rounded-md px-4 py-3 bg-gray-900 text-white hover:bg-white"
            >
              Get Access - 2mins
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConvertKitForm;
